import { FC, MouseEvent } from 'react';
import { useLocation } from 'react-router-dom';
import type { ExpertReportFeedbackItem } from '@/entities/expert-report';
import { buildEvaluationTargetKey, EVALUATION_TARGET_PARAM } from '@/features/DialogDataSection';
import { appGeneratePath, useAppNavigate } from '@/shared/lib';

type Props = {
  item: ExpertReportFeedbackItem;
};

/**
 * Ссылка на диалог, в котором сделана правка: карточка открывается на нужном заключении
 * и наводится на правленый элемент. Переход в том же окне запоминает адрес списка —
 * по нему «← Назад» возвращает в «Обратную связь»; клик с модификатором остаётся за браузером,
 * который открывает адрес в новом окне.
 */
export const FeedbackConversationLink: FC<Props> = ({ item }) => {
  const navigate = useAppNavigate();
  const location = useLocation();

  // Правка комментария ведёт к правилу, всякая другая — к блоку
  const target =
    item.commentChanged && item.ruleId !== null
      ? buildEvaluationTargetKey('rule', item.ruleId)
      : buildEvaluationTargetKey('block', item.blockId);

  const query = {
    tab: `expert-report-${item.expertReportId}`,
    [EVALUATION_TARGET_PARAM]: target,
  };
  const path = appGeneratePath('/dialogs/:id', { id: String(item.conversationId) });
  const href = `${path}?${new URLSearchParams(query).toString()}`;

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    navigate(
      '/dialogs/:id',
      { id: String(item.conversationId) },
      { query, state: `${location.pathname}${location.search}` },
    );
  };

  return (
    <a href={href} className="text-primary underline" onClick={handleClick}>
      {item.conversationId}
    </a>
  );
};
